(function(){
  // Bu yardımcı SADECE newsletter/popup'ı kapatmak için var.
  // Temanın KENDİ modallarına (sepet çekmecesi, ürün zoom, quick-add, arama,
  // menü, dialog) ASLA dokunmaz — aksi halde inline display:none ile kilitlenip
  // bir daha açılmazlar. O bileşenleri kendi JS'leri yönetir.
  var THEME_COMPONENTS = 'cart-drawer, product-modal, quick-add-modal, search-modal,' +
                         ' menu-drawer, modal-dialog, predictive-search, localization-form,' +
                         ' .product-media-modal, .cart-drawer-popup-modal, #CartDrawer';

  function isThemeManaged(el){
    return !!(el && el.closest && el.closest(THEME_COMPONENTS));
  }
  // Sadece gerçek newsletter/popup kapsayıcıları
  function popupContainer(el){
    if(!el || !el.closest) return null;
    if(isThemeManaged(el)) return null;
    return el.closest('[class*="popup"], [class*="newsletter"], [id*="popup-newsletter"]');
  }
  function hide(el){
    if(!el || isThemeManaged(el)) return;
    el.style.display='none';
    el.style.visibility='hidden';
    el.classList.remove('active','open','is-open','visible','show');
    try{ if(typeof el.close==='function') el.close(); }catch(e){}
    document.body.classList.remove('overflow-hidden','no-scroll','modal-open');
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('button, a, [role="button"], .close, [class*="close"]');
    if(!t || isThemeManaged(t)) return;
    var label = (t.textContent||'') + ' ' + (t.className||'') + ' ' +
                (t.getAttribute('aria-label')||'');
    if(!/close|kapat|dismiss/i.test(label)) return;
    var ov = popupContainer(t);
    if(ov){ e.preventDefault(); hide(ov); }
  });
  // ESC: sadece görünür newsletter/popup'ı kapat (tema modallarına dokunma)
  document.addEventListener('keydown', function(e){
    if(e.key!=='Escape') return;
    document.querySelectorAll('[class*="popup"], [class*="newsletter"]')
      .forEach(function(m){
        if(m.offsetParent!==null && !isThemeManaged(m)) hide(m);
      });
  });
})();
